const initialState = {
  fetched: false,
  status: '',
  pendencies: []
}

const PENDENCY_REQUEST = 'PENDENCY_REQUEST'
const PENDENCY_REQUEST_SUCCESS = 'PENDENCY_REQUEST_SUCCESS'
const PENDENCY_REQUEST_ERROR = 'PENDENCY_REQUEST_ERROR'

export const ACTION_TYPES = {
  PENDENCY_REQUEST,
  PENDENCY_REQUEST_SUCCESS,
  PENDENCY_REQUEST_ERROR
}

export const getPendency = () => ({
  type: PENDENCY_REQUEST
})

export const pendencySuccess = payload => ({ type: PENDENCY_REQUEST_SUCCESS, payload })
export const pendencyError = payload => ({ type: PENDENCY_REQUEST_ERROR, payload })

const handlePendencySuccess = (state, payload) => {
  const { status, actions } = payload.data

  const newState = {
    fetched: true,
    status,
    pendencies: actions
  }

  return newState
}

const pendency = (state = initialState, { type, payload }) => {
  switch (type) {
    case PENDENCY_REQUEST_SUCCESS:
      return handlePendencySuccess(state, payload)
    case PENDENCY_REQUEST_ERROR:
      return { ...state, fetched: true }
    default:
      return state
  }
}

export default pendency
